import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useContactDeleteMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (result: Api.IBulkOperationResult<string>) => void;
	onError?: (error: Api.IBulkOperationResult<string>) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ ids }: { ids: string[] }) => {
			return new Promise(resolve => {
				userSession.webServiceHelper.callWebServiceWithBulkOperationResult<string>(
					Api.ImpersonationBroker.composeApiUrl({
						urlPath: 'contact',
					}),
					'DELETE',
					ids,
					resolve,
					resolve
				);
			});
		},
		onError,
		onSuccess,
	});
}
